export * as errors              from './errors';
export * as function            from './function';
export * as string              from './string';
export * as object              from './object/index';
export * as DateWrapper         from './DateWrapper';
export * as translationsManager from './translationsManager';
export * as languageProcessing  from './languageProcessing/index';
export * as colors              from './colors';
export * as math                from './math';
export * as events              from './events';
export * as DOM                 from './DOM/index';
export * as misc                from './misc';
export const sessionId = _API.string.random(5);
import * as _API from './';
declare global {
	interface Window {
		API    : typeof _API;
		MPAAPI : typeof _API;
	}
};
(<Record<string, unknown>>globalThis).API    = _API;
(<Record<string, unknown>>globalThis).MPAAPI = _API;
